import styled from "styled-components"

export const StyledMessageList = styled.div`
  grid-area: m;
  padding-left: 6px;
  height: 100%;
  overflow: auto;
  background: white;

  .join-room {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-size: 34px;
    font-weight: 300;
}



`
